export default {
  inspectionLevel: [],
  inspectionLevelCode: null,

  productionGroups: [],
  productionGroup: {},
  productionGroupsCode: null,

  productionGroupSupplier: [],
  productionGroupSupplierCode: null,

  purchaseContracts: [],
  purchaseContractsCode: null,

  saleTypes: [],
  saleTypesCode: null,

  stopStations: [],
  stopStationsCode: null,

  orders: [],
  order: {},
  ordersCode: null,
  orderCommodityAttachment: [],

  orderDataSheet: [],
  orderDataSheets: {},
  orderDataSheetCode: null,

  settings: [],

  technicalCartable: [],
  inventoryControlCartable: [],
  mapConfirmCartable: [],

  deliveryDateCartable: [],

  confirmDeliveryDateCartable: [],

  isNeedPlanCartable: [],

  sellCartable: [],

  commodityAdditionalInfo: [],

  bomCommodities: {},
  boms: [],

  orderCommodityReservation: [],

  commodityInventoryWare: [],

  orderCommodityStatusLogs: [],

  modiranMappings: [],
  modiranSideWares: [],
  modiranSideVoucherTypes: [],
  modiranSideLoading: false,
  modiranSideError: null,
};
